import React, { useState } from "react"
import { Button, Card, CardBody, CardTitle, Col, Row } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { changeLayout, showRightSidebarAction } from "store/actions"
import { Link, useNavigate } from "react-router-dom"
import CommonChangePassword from "./CommonChangePassword"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { layoutTypes } from "constants/layout"
import { useTranslation } from "react-i18next"

const MyPreference = props => {
  const { t } = useTranslation()

  document.title = t("My Preference | Sign Burger")

  const urlParams = new URLSearchParams(window.location.search)
  const tabValue = urlParams.get("tab")
  const navigate = useNavigate()

  const [activeTab, setActiveTab] = useState(tabValue || "CHANGE_PASSWORD")

  const onChangeTabs = type => {
    setActiveTab(type)
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs />

        <Row>
          <Col xl={12}>
            <Card>
              <CardBody>
                <CardTitle>{t("My Preference")}</CardTitle>

                <Row className="mt-3">
                  <Col>
                    <ul className="nav nav-pills" style={{ minWidth: 80 }}>
                      <li className="nav-item">
                        <Link
                          to="#"
                          className={`nav-link ${
                            activeTab === "CHANGE_PASSWORD" ? "active" : ""
                          }`}
                          onClick={() => {
                            onChangeTabs("CHANGE_PASSWORD")
                          }}
                        >
                          {t("Change Password")}
                        </Link>{" "}
                      </li>
                      {/* <li className="nav-item">
                        <Link
                          to="#"
                          className={`nav-link ${
                            activeTab === "CHANGE_LANGUAGE" ? "active" : ""
                          }`}
                          onClick={() => {
                            onChangeTabs("CHANGE_LANGUAGE")
                          }}
                        >
                          Change Language
                        </Link>{" "}
                      </li> */}
                      <li className="nav-item">
                        <Link
                          to="#"
                          className={`nav-link ${
                            activeTab === "CHANGE_LAYOUT" ? "active" : ""
                          }`}
                          onClick={() => {
                            onChangeTabs("CHANGE_LAYOUT")
                          }}
                        >
                          {t("Change Layout")}
                        </Link>{" "}
                      </li>
                    </ul>
                  </Col>
                </Row>
                <Row className="mt-4">
                  <hr />
                </Row>
                <Row>
                  {/* TAB CONTENT */}
                  {activeTab === "CHANGE_PASSWORD" && (
                    <Col lg={4}>
                      <div>
                        <CommonChangePassword />
                      </div>
                    </Col>
                  )}

                  {activeTab === "CHANGE_LAYOUT" && (
                    <Col lg={6}>
                      <div>
                        <Button
                          style={{
                            backgroundColor: `${
                              props.layoutType === layoutTypes.VERTICAL
                                ? "#FF91C5"
                                : "#eff0f7"
                            }`,
                            border: "unset",
                            fontWeight: 600,
                            color: `${
                              props.layoutType === layoutTypes.VERTICAL
                                ? "#fff"
                                : "#495057"
                            }`,
                          }}
                          onClick={() => {
                            props.changeLayout(layoutTypes.VERTICAL)
                            navigate(`/my-preference?tab=CHANGE_LAYOUT`)
                          }}
                        >
                          {t("Vertical")}
                        </Button>
                        <Button
                          className="mx-2"
                          style={{
                            backgroundColor: `${
                              props.layoutType === layoutTypes.HORIZONTAL
                                ? "#FF91C5"
                                : "#eff0f7"
                            }`,
                            border: "unset",
                            fontWeight: 600,
                            color: `${
                              props.layoutType === layoutTypes.HORIZONTAL
                                ? "#fff"
                                : "#495057"
                            }`,
                          }}
                          onClick={() => {
                            props.changeLayout(layoutTypes.HORIZONTAL)
                            navigate(`/my-preference?tab=CHANGE_LAYOUT`)
                          }}
                        >
                          {t("Horizontal")}
                        </Button>
                      </div>
                    </Col>
                  )}
                </Row>

                {/* <div className="mt-4">
                  <Button
                    color="primary"
                    onClick={() => showRightSidebarAction(true)}
                  >
                    Change Setting
                  </Button>
                </div> */}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

// export default MyPreference

MyPreference.propTypes = {
  changeLayout: PropTypes.func,
}

const mapStateToProps = state => {
  return { ...state.Layout }
}

export default connect(mapStateToProps, {
  changeLayout,
})(MyPreference)
